import LandingSection from '@/components/landing/LandingSection'
import { Users } from 'react-feather'
import Creators from 'public/img/creators.svg'
import Link from 'next/link'

export default function Teaching() {
  return (
    <LandingSection
      title="Teaching"
      description="Make the life easier for your audience. Link to any book, paper or docs you mention. Do you have important text in your slides? Use Annotate.tv for easy copy/paste."
      canonical="/cases/teaching"
    >
      <div className="bg-gray-50 flex flex-col center px-6 flex-1">
        <div className="mx-auto px-4 sm:px-6 md:max-w-7xl">
          <div className="my-10">
            <div className="grid grid-cols-1 md:grid-cols-2 md:gap-4">
              <div className="center mb-5 md:block md:mb-0">
                <Creators
                  role="img"
                  aria-label="Educator annotating a video lesson for students"
                />
              </div>

              <div className="flex justify-center flex-col mt-10 md:ml-10 md:mt-0">
                <div>
                  <span className="h-12 w-12 rounded-md center bg-primary">
                    <Users className="h-6 w-6 text-white" />
                  </span>
                </div>
                <div className="mt-6">
                  <h1 className="text-4xl tracking-tight font-extrabold md:text-6xl xl:text-7xl text-gray-900">
                    Teaching
                  </h1>
                  <p className="mt-4 text-xl text-gray-500">
                    Multiple features are developed on Annotate.tv by keeping a
                    teacher’s perspective in mind.
                  </p>
                  <p className="mt-4 text-xl text-gray-500">
                    Make the life easier for your audience. Link to any book,
                    paper or docs you mention. Share a link with all your most
                    important texts for easy copy/paste. Want to add something?
                    No need to re-shoot your video, just edit your notes.
                  </p>
                  <div className="mt-4">
                    <a
                      className="clickable-opacity text-primary underline text-xl"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://annotate.tv/watch/6037cf28dd387c620366da9b"
                    >
                      Check a real-world example
                    </a>
                  </div>
                  <div className="mt-6">
                    <Link href="/signup">
                      <a className="inline-flex clickable-opacity px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary">
                        Get started
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LandingSection>
  )
}
